import {
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
} from "@coreui/react";
import React, { useContext, useState } from "react";
import TableFooter from './TableFooter';
import { AlertsContext } from '../../context/AlertsContext';
import { getDate } from '../../utils/getDate';


const Table = ({ columns, data, pagination }) => {

  const {setAlertsPageUrl} = useContext(AlertsContext);

  return (
      <>
          <CTable responsive hover>
              <CTableHead>
                  <CTableRow>
                      {columns?.map((col, index) => (
                          <CTableHeaderCell key={index} scope="col" style={{whiteSpace: "nowrap"}}>
                              {col.label}
                          </CTableHeaderCell>
                      ))}
                  </CTableRow>
              </CTableHead>
              <CTableBody>
                  {data?.map((el, index) => {
                    return (
                        <CTableRow key={index}>
                            <CTableDataCell>
                                {getDate(el.date_of_alert)}
                            </CTableDataCell>
                            <CTableDataCell>{el.type.name}</CTableDataCell>
                            <CTableDataCell>{el.status.name}</CTableDataCell>
                            <CTableDataCell>
                                {el.pet.name || "-"}
                            </CTableDataCell>
                            <CTableDataCell>{el.pet.specie}</CTableDataCell>
                            <CTableDataCell>
                                {el.pet.gender || "-"}
                            </CTableDataCell>
                            <CTableDataCell>{el.pet.age || "-"}</CTableDataCell>
                            <CTableDataCell>
                                {el?.location?.address}
                            </CTableDataCell>
                            <CTableDataCell>
                                {el?.location?.zip_code
                                    ? el.location.zip_code
                                    : "-"
                                }
                            </CTableDataCell>
                            <CTableDataCell>
                                {el.user?.id}                
                            </CTableDataCell>
                            <CTableDataCell>
                                {el.user?.name}                
                            </CTableDataCell>
                            <CTableDataCell>
                                {el.user?.email}                
                            </CTableDataCell>
                            <CTableDataCell>
                                {el.user?.phone_country_code}                
                            </CTableDataCell>
                            <CTableDataCell>
                                {el.user?.phone_area_code}                
                            </CTableDataCell>
                            <CTableDataCell>
                                {!el.user?.phone_country_code ? el.user?.phone : el.user?.phone_number}                
                            </CTableDataCell>
                            <CTableDataCell>{el.responses}</CTableDataCell>
                            {/* <CTableDataCell>
                  <CButton
                    className={el.is_active ? styles['isActive'] : styles['isSuspended']}
                    // onClick={() => handleAction(el.id)}
                  >
                    {el.is_active ? 'Suspender' : 'Reactivar'}
                  </CButton>
                </CTableDataCell> */}
                        </CTableRow>
                    );})}
              </CTableBody>
          </CTable>
          <TableFooter
              range={pagination?.links}
              setPageUrl={setAlertsPageUrl}
          />
      </>
  );
};

export default Table;
